// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LinkOrSpan from '../../../shared/components/link-or-span';
import {buildFilterQueryString} from '../../shared/services/build-query';

const buildQuery = (queryParams, data) =>
    data.account ?
        `leadAccount=${data.leadAccount}&postingDateFrom=${queryParams.postingDateFrom}&postingDateTo=${queryParams.postingDateTo}&city=${encodeURIComponent(data.city)}&account=${data.account}&leadAccountDisplayName=${encodeURIComponent(data.leadAccountDisplayName)}` :
        `leadAccount=${data.leadAccount}&postingDateFrom=${queryParams.postingDateFrom}&postingDateTo=${queryParams.postingDateTo}&city=${encodeURIComponent(data.city)}&leadAccountDisplayName=${encodeURIComponent(data.leadAccountDisplayName)}`;

const LinkToClaimsRenderer = props => {

    if (props.value === null) {

        return <span/>;

    }

    const returnValue = props.children ? props.children : props.value;

    return (
        <LinkOrSpan
            actualValue={returnValue}
            displayValue={returnValue}
            link={`/reimbursement-summary/claims?${buildQuery(props.colDef.queryParams, props.data)}${buildFilterQueryString(props.colDef.unpaidFilter)}`}
        />
    );

};

LinkToClaimsRenderer.displayName = 'LinkToClaimsRenderer';
LinkToClaimsRenderer.propTypes = {
    children: PropTypes.node,
    colDef: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default LinkToClaimsRenderer;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/details/components/link-to-claims-renderer.js